import { render, staticRenderFns } from "./SurveyOptionsManager.vue?vue&type=template&id=060c9f61&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports